import { api } from "./client";
import type { FileDTO, FolderDTO } from "@titancloud/shared";

export async function listTrash(params: { limit?: number; offset?: number } = {}): Promise<{
  files: FileDTO[];
  folders: FolderDTO[];
  totalFiles: number;
  totalRootFolders: number;
}> {
  const qs = new URLSearchParams();
  if (params.limit) qs.set("limit", String(params.limit));
  if (params.offset) qs.set("offset", String(params.offset));
  return api.get(`/trash?${qs.toString()}`);
}

export async function listTrashFolder(folderId: string): Promise<{
  folder: FolderDTO;
  files: FileDTO[];
  folders: FolderDTO[];
}> {
  return api.get(`/trash/folder/${folderId}`);
}

export async function restoreItem(
  id: string,
  type: "file" | "folder"
): Promise<void> {
  await api.post(`/trash/${id}/restore`, { type });
}

export async function permanentDeleteItem(
  id: string,
  type: "file" | "folder"
): Promise<void> {
  await api.delete(`/trash/${id}?type=${type}`);
}

export async function emptyTrash(): Promise<void> {
  await api.delete("/trash/empty");
}

export async function getTrashDownloadUrl(
  fileId: string,
  signal?: AbortSignal
): Promise<{ url: string }> {
  return api.get(`/trash/files/${fileId}/download-url`, signal ? { signal } : {});
}

/** Batch-fetches download URLs for several trashed files in one request — used to prefetch preview neighbors. */
export async function getTrashDownloadUrls(
  fileIds: string[],
  signal?: AbortSignal
): Promise<{ urls: Record<string, string> }> {
  return api.post("/trash/files/download-urls", { fileIds }, signal ? { signal } : {});
}
